import { FC, useMemo } from 'react';
import { Banner } from '@servicetitan/design-system';
import { inboxLocators } from '@locators/inbox';

interface FailedSearchInTenantsAlertProps {
  failedTenants: string[] | null;
  onClose: () => void;
}

export const FailedSearchInTenantsAlert: FC<FailedSearchInTenantsAlertProps> = (
  props,
) => {
  const alertTitle = useMemo(() => {
    if (props.failedTenants?.length) {
      const tenantNames = props.failedTenants.join(', ');

      return `Unable to return search results for: ${tenantNames}`;
    }

    return 'Unable to return search results from some tenants';
  }, [props.failedTenants]);

  return (
    <Banner
      status='warning'
      id={inboxLocators.customerSearch.failedTenantsAlert}
      className='m-b'
      onClose={props.onClose}
      icon
      primaryActionName='Reload Table'
      title={alertTitle}
    />
  );
};
